import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="page-footer">
            <p className="footer-disclaimer">
                This site is not affiliated with, endorsed by, or sponsored by
                NetEase Games or Marvel Entertainment. Marvel Rivals and all
                related names, characters, and marks are trademarks of their
                respective owners.
            </p>
            <div className="footer-links">
                <Link to="/faq" className="footer-link">
                    FAQ
                </Link>
                <a
                    href="https://rivalsanalytics.bsky.social"
                    className="footer-link"
                    target="_blank"
                    rel="noreferrer"
                >
                    Bluesky
                </a>
                <a
                    href="https://ko-fi.com/rivalsanalyticx"
                    className="footer-link"
                    target="_blank"
                    rel="noreferrer"
                >
                    Help support this project ♥
                </a>
            </div>
        </footer>
    );
}
